<template>
    <div>
        <app-header></app-header>
        <div class="page-wrap">
        <div class="banner">
            <img src="../../assets/images/banner.jpg">
        </div>
        <div class="tabs">
            <div class="clearfix tab-box">
                <div class="tab-item" :class="num == 1 ? 'active': ''"  @click="changeNum(1)">单位会员介绍</div>
                <div class="tab-item" :class="num == 2 ? 'active': ''"  @click="changeNum(2)">个人会员介绍</div>
                <div class="tab-item" :class="num == 3 ? 'active': ''"  @click="changeNum(3)">章程</div> 
            </div>
        </div>
        <div class="tab-content">
            <div class="tab-content-item" v-if="num == 1">
                <div class="welcome">欢迎加入中国交通运输协会</div>
                <div class="tab-content-part bg-grey">
                    <div class="main-box">
                        <div class="title">单位会员介绍</div>
                        <p class="desc">从事交通运输、物流事业，拥护本会章程，有加入本会的意愿，在相关业务、行业和学科领域内具有一定影响的企业事业单位。</p>
                        <div class="appli-button" @click="toApply(1)">申请入会</div>
                    </div>
                </div>
                <div class="tab-content-part">
                    <div class="main-box">
                        <div class="title">入会流程</div>
                        <div class="img-box" style="height:98px">
                            <img class="tab-img" src="../../assets/images/home-3.png" >
                        </div>
                    </div>
                </div>
                <div class="tab-content-part bg-grey">
                    <div class="main-box">
                        <div class="title">会员的权利和义务</div>
                        <div>
                            <div class="ro-tab clseafix">
                                <div class="ro-tab-item pull-left" :class="subNum == 1 ? 'active': ''"  @click="changeSubNum(1)">会员权利</div>
                                <div class="ro-tab-item pull-left" :class="subNum == 2 ? 'active': ''"  @click="changeSubNum(2)">会员义务</div>
                            </div>
                            <div class="sub-tab-desc" v-if="subNum == 1">
                                <p>一、本会的选举权、被选举权和表决权;</p>
                                <p>二、参加本会的活动；</p>
                                <p>三、获得本会服务的优先权：</p>
                                <p>（一）获中国交通运输协会的会员证书，享受会员单位荣誉及在各项服务活动中享受会员级别的优惠待遇；</p>
                                <p>（二）在协会网站的《会员风采》专区内发布文字500字左右、照片2-3幅的单位简介；</p>
                                <p>（三）通过多种方式向会员单位介绍国家在交通运输领域的政策、法规及经济发展动态；传递市场信息以及国内外同行业市场发展动态，为会员单位提供信息咨询服务；</p>
                                <p>（四）汇总会员单位提出的行业发展规划、产业政策、行业标准制定、经济立法等意见，向政府有关部门反映；协调与相关行业间的沟通交流；</p>
                                <p>（五）优先参加协会组织的各项活动，如大型论坛、展会、国内外考察、交流访问等活动；</p>
                                <p>（六）协助会员单位办理参加协会组织的各种职业培训和考试，协助会员单位对员工进行培训。</p>
                                <p>四、对本会工作的批评建议权和监督权;</p>
                                <p>五、入会自愿、退会自由</p>
                            </div>
                            <div class="sub-tab-desc" v-if="subNum == 2">
                                <p>一、执行本会的决议</p>
                                <p>二、维护本会合法权益;</p>
                                <p>三、完成本会交办的工作;</p>
                                <p>四、按规定缴纳会费;</p>
                                <p>五、向本会反映情况、提供有关资料。</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="tab-content-part ">
                    <div class="main-box">
                        <div class="title">会费标准及类型</div>
                        <div class="img-box"  >
                            <img class="tab-img" src="../../assets/images/home-2.png">
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-content-item" v-if="num == 2">
                <div class="welcome">欢迎加入中国交通运输协会</div>
                <div class="tab-content-part bg-grey">
                    <div class="main-box">
                        <div class="title">个人会员介绍</div>
                        <p class="desc">从事交通运输、物流事业，拥护本会章程，有加入本会的意愿，具有正高级技术职称，在相关业务、行业和学科领域内具有一定影响，取得显著成果、做出重要贡献的个人。</p>
                        <div class="appli-button" @click="toApply(2)">申请入会</div>
                    </div>
                </div>
                <div class="tab-content-part">
                    <div class="main-box">
                        <div class="title">入会流程</div>
                        <div class="img-box" style="height:98px">
                            <img class="tab-img" src="../../assets/images/home-1.png" >
                        </div>
                    </div>
                </div>
                 <div class="tab-content-part bg-grey">
                    <div class="main-box">
                        <div class="title">会员的权利和义务</div>
                        <div>
                            <div class="ro-tab clseafix">
                                <div class="ro-tab-item pull-left" :class="subNum == 1 ? 'active': ''"  @click="changeSubNum(1)">会员权利</div>
                                <div class="ro-tab-item pull-left" :class="subNum == 2 ? 'active': ''"  @click="changeSubNum(2)">会员义务</div>
                            </div>
                            <div class="sub-tab-desc" v-if="subNum == 1">
                                <p>一、本会的选举权、被选举权和表决权;</p>
                                <p>二、参加本会的活动；</p>
                                <p>三、获得本会服务的优先权：</p>
                                <p>（一）获中国交通运输协会的会员证书，享受会员荣誉及在各项服务活动中享受会员级别的优惠待遇；</p>
                                <p>（二）通过多种方式向个人会员介绍国家在交通运输领域的政策、法规及经济发展动态；传递市场信息以及国内外同行业市场发展动态；</p>
                                <p>（三）优先参加协会组织的各项活动，如大型论坛、展会、国内外考察、交流访问等活动；</p>
                                <p>（四）优先参加协会组织的各种职业培训和考试。</p>
                                <p>四、对本会工作的批评建议权和监督权;</p>
                                <p>五、入会自愿、退会自由。</p>

                             
                            </div>
                            <div class="sub-tab-desc" v-if="subNum == 2">
                                <p>一、执行本会的决议;</p>
                                <p>二、维护本会合法权益;</p>
                                <p>三、完成本会交办的工作;</p>
                                <p>四、向本会反映情况、提供有关资料。</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="tab-content-part">
                    <div class="main-box">
                        <div class="title">会费标准及类型</div>
                        <div class="img-box"  >
                            <img class="tab-img" src="../../assets/images/home-2.png">
                        </div>
                    </div>
                </div>

            </div>
            <div class="tab-content-item" v-if="num == 3">
                <div class="tab-content-part bg-grey">
                    <div class="main-box">
                        <div class="title">章程</div>
                        <div class="constitution">
                            <div id="u84_text"><p><span style="text-decoration:none;">　　第一章 总 则</span></p><p><span style="text-decoration:none;">　　第一条 本会名称中国交通运输协会，简称中国交协或者中交协;英文译名China Communications and Transportation Association;缩写CCTA。</span></p><p><span style="text-decoration:none;">　　第二条 本会是由交通运输、铁路、民航、邮政和军事交通等部门和单位共同发起，从事交通运输、物流等有关企业事业单位及个人自愿结成，具有法人资格的全国性、行业性、非营利性社会组织。</span></p><p><span style="text-decoration:none;">　　第三条 本会的宗旨是：坚持以马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观、习近平新时代中国特色社会主义思想为指导，树立“四个意识”，坚定“四个自信”，坚持新发展理念，围绕统筹推进“五位一体”总体布局和协调推进“四个全面”战略布局，结合社会组织领域的“放管服”改革，加快协会转型，努力适应新常态、新规则、新要求，履行为国家、为行业、为企业、为社会服务的职能，当好桥梁纽带和参谋助手，推动综合交通运输和现代物流业发展，发挥本会在经济发展新常态中的独特优势和应有作用，为建设交通强国贡献力量。</span></p><p><span style="text-decoration:none;">　　本会遵守宪法、法律、法规和国家政策，践行社会主义核心价值观，遵守社会道德风尚，推动行业诚信建设。本会党组织贯彻落实中央关于推进社会组织党建工作“两个覆盖”部署，坚持“三重一大”决策制度，融合党务业务队伍建设，为完成好本会工作任务提供政治、思想和组织保障，将本会建设成为依法设立、权责明确、自主办会、服务为本、治理规范、行为自律的现代社会组织。</span></p><p><span style="text-decoration:none;">　　第四条 本会的登记管理机关是民政部。</span></p><p><span style="text-decoration:none;">　　本会接受登记管理机关和相关职能部门的业务指导和监督管理。</span></p><p><span style="text-decoration:none;">　　第五条 本会根据中国共产党章程的规定，设立中国共产党的组织，开展党的活动，为党的组织的活动提供必要条件。</span></p><p><span style="text-decoration:none;">　　第六条 本会的住所设在北京市。</span></p><p><span style="text-decoration:none;">　　第二章 业务范围</span></p><p><span style="text-decoration:none;">　　第七条 本会的业务范围：</span></p><p><span style="text-decoration:none;">　　(一)在健全社会主义市场经济体制进程中，为政府部门建立统一、开放、竞争、有序的现代化综合交通运输体系和现代物流体系提供支撑;围绕实现交通强国的战略目标，为政府部门开展涉及多种运输方式和物流业的法律、法规、条例等制度建设和改革提供支撑;</span></p><p><span style="text-decoration:none;">　　(二)为政府部门审批国际性、全国性、区域性综合交通运输网、综合交通运输枢纽、综合交通运输大通道、综合交通运输和现代物流业，以及物流基础设施的中长期发展规划提供支撑;经政府有关部门批准，承担相关规划与重大项目等前期论证、评估及后评价，开展相关专题研究;</span></p><p><span style="text-decoration:none;">　　(三)推动交通运输和现代物流业的协调发展与运行,开展行业舆情监测;为政府部门对多种运输方式竞争市场的监测与协调提供支撑;为政府运价管理部门对多种运输方式竞争性领域的价格监测与协调提供支撑;</span></p><p><span style="text-decoration:none;">　　(四)在政府部门和军事交通部门指导下，参与研究在交通运输、现代物流业的生产建设中贯彻执行“军民结合、平战结合”方针及相关政策措施;</span></p><p><span style="text-decoration:none;">　　(五)推动静态交通和动态交通的协调发展;促进业内外多种形式投融资合作机制的发展;推进交通运输和现代物流业信息化、智能化的发展;</span></p><p><span style="text-decoration:none;">　　(六)经政府有关部门批准或委托，参与跨区域联运体系发展的标准和规范的制定修订;参与跨运输方式、跨区域的危险品、冷链、大件以及邮轮、游艇、房车、快运等特种运输和物流企业等标准及资质规范的制定修订;按照规定经批准，在政府部门监督下，开展交通运输和物流企业的资质认证;开展交通运输和物流职业培训及资格认证工作;</span></p><p><span style="text-decoration:none;">　　(七)推动交通运输和现代物流业科技进步，按照规定经批准，开展企业质量评价、先进企业评价和科技创新评价;推动交通运输和现代物流业的新技术、新业态、新产品、新领域的创新发展;推动业内科研成果向生产力转化;倡导和建立健全行业节能减排、低碳交通运输和物流的工作体系;</span></p><p><span style="text-decoration:none;">　　(八)推动交通运输和物流行业自律，开展行业信用评价，促进诚信自律体系建设;</span></p><p><span style="text-decoration:none;">　　(九)依照有关规定编辑出版交通年鉴和交通运输、现代物流业相关的书刊，编辑发行会刊和信息资料;组织会议展览活动，为会员传递信息、交流经验和发表相关见解提供服务平台;</span></p><p><span style="text-decoration:none;">　　(十)在国家对外政策指导下，开展与国际运输和现代物流业非政府性组织的交流合作;开展与港、澳、台地区相关社会团体和企业之间的联系;开展国内外同业间技术经济和经营管理等方面的交流考察活动;</span></p><p><span style="text-decoration:none;">　　(十一)开展与相关行业协会、地方交通运输和物流协会的交流合作;向政府部门反映行业情况和企业诉求，提出行业发展的方针、政策、战略、规划和建设项目等方面的咨询建议，维护行业和会员的合法权益;</span></p><p><span style="text-decoration:none;">　　(十二)接受政府部门和企事业单位的委托项目;参与承接政府购买行业规范、行业评价、行业统计、行业标准、职业评价、定级评定等行业管理与协调性服务，技术推广、行业规划、行业调查、行业发展与管理政策及重大事项决策咨询等技术性服务，以及专业性较强的社会管理服务。</span></p><p><span style="text-decoration:none;">　　业务范围中属于法律法规规章规定须经批准的事项，依法经批准后开展。</span></p><p><span style="text-decoration:none;">　　第三章 会 员</span></p><p><span style="text-decoration:none;">　　第八条 本会会员分为单位会员和个人会员。</span></p><p><span style="text-decoration:none;">　　第九条 申请加入本会的会员，必须具备下列基本条件：</span></p><p><span style="text-decoration:none;">　　(一)拥护本会章程;</span></p><p><span style="text-decoration:none;">　　(二)有加入本会的意愿;</span></p><p><span style="text-decoration:none;">　　(三)在本会的业务、行业和学科领域内具有一定的影响。</span></p><p><span style="text-decoration:none;">　　第十条 会员入会的程序是：</span></p><p><span style="text-decoration:none;">　　(一)提交入会申请书和有关证明材料;</span></p><p><span style="text-decoration:none;">　　(二)经理事会讨论通过;</span></p><p><span style="text-decoration:none;">　　(三)由理事会或理事会授权的机构批复和发给会员证。</span></p><p><span style="text-decoration:none;">　　第十一条 会员享有下列权利：</span></p><p><span style="text-decoration:none;">　　(一)本会的选举权、被选举权和表决权;</span></p><p><span style="text-decoration:none;">　　(二)参加本会的活动;</span></p><p><span style="text-decoration:none;">　　(三)获得本会服务的优先权;</span></p><p><span style="text-decoration:none;">　　(四)对本会工作的批评建议权和监督权;</span></p><p><span style="text-decoration:none;">　　(五)入会自愿、退会自由。</span></p><p><span style="text-decoration:none;">　　第十二条 会员履行下列义务：</span></p><p><span style="text-decoration:none;">　　(一)执行本会的决议;</span></p><p><span style="text-decoration:none;">　　(二)维护本会合法权益;</span></p><p><span style="text-decoration:none;">　　(三)完成本会交办的工作;</span></p><p><span style="text-decoration:none;">　　(四)按规定缴纳会费;</span></p><p><span style="text-decoration:none;">　　(五)向本会反映情况、提供有关资料。</span></p><p><span style="text-decoration:none;">　　第十三条 会员退会应书面通知本会，并交回会员证。会员如果连续 1年不交纳会费或不参加本会活动的，视为自动退会。</span></p><p><span style="text-decoration:none;">　　第十四条 对于加入或退出的会员，本会将通过有关网站、刊物或媒体向社会公布。</span></p><p><span style="text-decoration:none;">　　第十五条 会员如有严重违反本章程的行为，经理事会或常务理事会表决通过，予以除名和公告。</span></p><p><span style="text-decoration:none;">　　第四章 组织机构和负责人产生、罢免</span></p><p><span style="text-decoration:none;">　　第十六条 本会的最高权力机构是会员代表大会，会员代表大会的职权是：</span></p><p><span style="text-decoration:none;">　　(一)制定和修改章程;</span></p><p><span style="text-decoration:none;">　　(二)选举和罢免理事;</span></p><p><span style="text-decoration:none;">　　(三)审议理事会的工作报告和财务报告;</span></p><p><span style="text-decoration:none;">　　(四)制定和修改会费标准;</span></p><p><span style="text-decoration:none;">　　(五)决定终止事宜;</span></p><p><span style="text-decoration:none;">　　(六)决定其他重大事宜。</span></p><p><span style="text-decoration:none;">　　第十七条 会员代表大会须有2/3以上的会员代表出席方能召开，其决议须经到会会员代表半数以上表决通过方能生效。</span></p><p><span style="text-decoration:none;">　　第十八条 会员代表大会每届5年。因特殊情况需提前或延期换届的，须由理事会表决通过，报业务主管单位审查并经社团登记管理机关批准。但延期换届最长不超过1年。</span></p><p><span style="text-decoration:none;">　　第十九条 理事会是会员代表大会的执行机构，在会员代表大会闭会期间领导本会开展日常工作，对会员代表大会负责。</span></p><p><span style="text-decoration:none;">　　第二十条 理事会的职权是：</span></p><p><span style="text-decoration:none;">　　(一)执行会员代表大会的决议;</span></p><p><span style="text-decoration:none;">　　(二)选举和罢免会长、副会长、秘书长、常务理事;</span></p><p><span style="text-decoration:none;">　　(三)筹备召开会员代表大会;</span></p><p><span style="text-decoration:none;">　　(四)向会员代表大会报告工作和财务状况;</span></p><p><span style="text-decoration:none;">　　(五)决定会员的吸收和除名;</span></p><p><span style="text-decoration:none;">　　(六)决定办事机构、分支机构、代表机构和实体机构的设立、变更和终止;</span></p><p><span style="text-decoration:none;">　　(七)决定副秘书长、各机构主要负责人的聘任;</span></p><p><span style="text-decoration:none;">　　(八)领导本会各机构开展工作;</span></p><p><span style="text-decoration:none;">　　(九)制定内部管理制度;</span></p><p><span style="text-decoration:none;">　　(十)决定其他重大事项。</span></p><p><span style="text-decoration:none;">　　第二十一条 理事会须有2/3 以上理事出席方能召开，其决议须经到会理事2/3 以上表决通过方能生效。</span></p><p><span style="text-decoration:none;">　　第二十二条 理事会每年召开一次会议;情况特殊的，也可采用通讯形式召开。</span></p><p><span style="text-decoration:none;">　　第二十三条 本会设立常务理事会。常务理事会由理事会选举产生。在理事会闭会期间，行使第二十条第(一)(三)(五)(六)(七)(八)(九)项的职权，对理事会负责(常务理事人数不超过理事人数的1/3)。</span></p><p><span style="text-decoration:none;">　　第二十四条 常务理事会须有2/3以上常务理事出席方能召开，其决议须经到会常务理事2/3 以上表决通过方能生效。</span></p><p><span style="text-decoration:none;">　　第二十五条 常务理事会至少半年召开一次会议;情况特殊的也可采用通讯形式召开。</span></p><p><span style="text-decoration:none;">　　第二十六条 本会的会长、副会长、秘书长必须具备下列条件：</span></p><p><span style="text-decoration:none;">　　(一)坚持党的路线、方针、政策，政治素质好;</span></p><p><span style="text-decoration:none;">　　(二)在本会业务领域内有较大影响;</span></p><p><span style="text-decoration:none;">　　(三)会长、副会长最高任职年龄不超过70周岁;</span></p><p><span style="text-decoration:none;">　　(四)秘书长最高任职年龄不超过70周岁，秘书长为专职;</span></p><p><span style="text-decoration:none;">　　(五)身体健康，能坚持正常工作;</span></p><p><span style="text-decoration:none;">　　(六)未受过剥夺政治权利的刑事处罚的;</span></p><p><span style="text-decoration:none;">　　(七)具有完全民事行为能力。</span></p><p><span style="text-decoration:none;">　　第二十七条 本会会长、副会长、秘书长如超过最高任职年龄的,须经理事会表决通过，报业务主管单位审查同意并经社团登记管理机关批准后，方可任职。</span></p><p><span style="text-decoration:none;">　　第二十八条 本会会长、副会长、秘书长每届任期5年，任期最长不得超过两届。因特殊情况需延长任期的，须经会员代表大会2/3 以上会员代表表决通过，报业务主管单位审查并经社团登记管理机关批准后方可任职。</span></p><p><span style="text-decoration:none;">　　第二十九条 本会会长为本会法定代表人。法定代表人代表本会签署有关重要文件。因特殊情况，经会长委托、理事会同意，报业务主管单位审查并经社团登记管理机关批准后，可由副会长或秘书长担任本会法定代表人。聘任或向社会公开招聘的秘书长，不得任本会法定代表人。</span></p><p><span style="text-decoration:none;">　　本会法定代表人不兼任其他团体的法定代表人。</span></p><p><span style="text-decoration:none;">　　第三十条 本会会长行使下列职权：</span></p><p><span style="text-decoration:none;">　　(一)召集和主持理事会、常务理事会;</span></p><p><span style="text-decoration:none;">　　(二)检查会员代表大会 、理事会、常务理事会决议的落实情况。</span></p><p><span style="text-decoration:none;">　　(三)召集和主持会长办公会，确定会长办公会列席人员。</span></p><p><span style="text-decoration:none;">　　第三十一条 本会秘书长行使下列职权：</span></p><p><span style="text-decoration:none;">　　(一)主持办事机构开展日常工作，组织实施年度工作计划;</span></p><p><span style="text-decoration:none;">　　(二)协调分支机构、代表机构、实体机构开展工作;</span></p><p><span style="text-decoration:none;">　　(三)提名副秘书长以及各办事机构、分支机构、代表机构和实体机构主要负责人，交理事会或常务理事会决定;</span></p><p><span style="text-decoration:none;">　　(四)决定办事机构、代表机构、实体机构专职工作人员的聘用;</span></p><p><span style="text-decoration:none;">　　(五)处理有关日常事务。</span></p><p><span style="text-decoration:none;">　　第五章 资产管理、使用原则</span></p><p><span style="text-decoration:none;">　　第三十二条本会经费来源：</span></p><p><span style="text-decoration:none;">　　(一)会费;</span></p><p><span style="text-decoration:none;">　　(二)捐赠;</span></p><p><span style="text-decoration:none;">　　(三)政府资助;</span></p><p><span style="text-decoration:none;">　　(四)在核准的业务范围内开展活动和服务的收入;</span></p><p><span style="text-decoration:none;">　　(五)利息;</span></p><p><span style="text-decoration:none;">　　(六)财政拨款;</span></p><p><span style="text-decoration:none;">　　(七)其他合法收入。</span></p><p><span style="text-decoration:none;">　　第三十三条 本会按照国家有关规定收取会员会费。本团体开展评比、评选、表彰等活动，不收取任何费用。</span></p><p><span style="text-decoration:none;">　　第三十四条 本会经费必须用于本章程规定的业务范围和事业的发展，不得在会员中分配。</span></p><p><span style="text-decoration:none;">　　第三十五条 本会建立严格的财务管理制度，保证会计资料合法、真实、准确、完整。</span></p><p><span style="text-decoration:none;">　　第三十六条 本会配备具有专业资格的会计人员。会计不得兼任出纳。会计人员必须进行会计核算，实行会计监督。会计人员调动工作或离职时，必须与接管人员办清交接手续。</span></p><p><span style="text-decoration:none;">　　第三十七条 本会的资产管理必须执行国家规定的财务管理制度，接受会员代表大会和财政部门的监督。资产来源属于国家拨款或者社会捐赠、资助的，必须接受审计机关的监督，并将有关情况以适当方式向社会公布。</span></p><p><span style="text-decoration:none;">　　第三十八条 本会换届或更换法定代表人之前，必须接受财务审计。</span></p><p><span style="text-decoration:none;">　　第三十九条 本会的资产，任何单位、个人不得侵占、私分和挪用。</span></p><p><span style="text-decoration:none;">　　第四十条 本会专职工作人员的工资和保险、福利待遇，参照国家对事业单位的有关规定执行。</span></p><p><span style="text-decoration:none;">　　第六章 章程的修改程序</span></p><p><span style="text-decoration:none;">　　第四十一条 对本会章程的修改，须经理事会表决通过后报会员代表大会审议。</span></p><p><span style="text-decoration:none;">　　第四十二条 本会修改的章程，须在会员代表大会通过后15日内，经业务主管单位审查同意，并报社团登记管理机关核准后生效。</span></p><p><span style="text-decoration:none;">　　第七章 终止程序及终止后的财产处理</span></p><p><span style="text-decoration:none;">　　第四十三条 本会完成宗旨或自行解散或由于分立、合并等原因需要注销的，由理事会或常务理事会提出终止动议。</span></p><p><span style="text-decoration:none;">　　第四十四条 本会终止动议须经会员代表大会表决通过，并报业务主管单位审查同意。</span></p><p><span style="text-decoration:none;">　　第四十五条 本会终止前，须在业务主管单位及有关机关指导下成立清算组织，清理债权债务，处理善后事宜。清算期间，不开展清算以外的活动。</span></p><p><span style="text-decoration:none;">　　第四十六条 本会经社团登记管理机关办理注销登记手续后即为终止。</span></p><p><span style="text-decoration:none;">　　第四十七条 本会终止后的剩余财产，在业务主管单位和社团登记管理机关的监督下，按照国家有关规定，用于发展与本会宗旨相关的事业。</span></p><p><span style="text-decoration:none;">　　第八章 附 则</span></p><p><span style="text-decoration:none;">　　第四十八条 本章程经2018年12月10日第七届会员代表大会表决通过。</span></p><p><span style="text-decoration:none;">　　第四十九条 本章程的解释权属本会的理事会。</span></p><p><span style="text-decoration:none;">　　第五十条 本章程自社团登记管理机关核准之日起生效。</span></p></div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        </div><!-- /page-wrap -->
        <app-footer></app-footer>
    </div>
</template>
<script>
import AppHeader from '@/views/portal/components/AppHeader.vue'
import AppFooter from '@/views/portal/components/AppFooter.vue'
import { IndexStore } from '@/store/module/index'
export default {
    components: { AppHeader, AppFooter },
    data () {
        return {
            num: 1,
            subNum: 1,
            userInfo: {}
        }
    },
    mounted () {
        window.scrollTo(0, 0)
    },
    methods: {
        changeNum (val) {
            this.num = val;
            this.subNum = 1;
        },
        changeSubNum (val) {
            this.subNum = val;
        },
        toApply (val) {
            // 未登录 → 跳转登录
            if (!window.localStorage.getItem('token')) {
                this.$router.push('/login')
                return
            }
            // 已登录 → 检查角色
            var userInfo = IndexStore.userInfo || {}
            var roles = userInfo.userRoles ? userInfo.userRoles.split(',') : []
            if (roles.indexOf('ROLE_branch_org') !== -1) {
                this.$router.push('/ROLE_branch_org')
            } else {
                this.$router.push('/serve')
            }
        }
    }
}
</script>
<style lang="less" scoped>
/* AppHeader 为 fixed，需要留出空间 */
.page-wrap {
    padding-top: 92px; /* < 640px: 36px top-bar + 12px*2 padding + 32px logo */
}
@media (min-width: 640px) {
    .page-wrap {
        padding-top: 112px; /* 36px + 16px*2 + 44px logo */
    }
}
@media (min-width: 1024px) {
    .page-wrap {
        padding-top: 155px; /* 含导航栏: 112px + ~43px nav */
    }
}
.main-box {
    max-width: 1000px;
    width: 100%;
    margin: 0 auto;
    padding: 0 16px;
    position: relative;
    box-sizing: border-box;
}
.banner {
    width: 100%;
    overflow: hidden;
    img {
        width: 100%;
        display: block;
    }
}
.tabs {
    width: 100%;
    padding-top: 10px;
    border-bottom: 1px solid #E9E9E9;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    .tab-box {
        display: flex;
        justify-content: center;
        white-space: nowrap;
    }
    .tab-item {
        flex: none;
        font-size: 22px;
        font-weight: normal;
        color: #474747;
        line-height: 57px;
        margin: 0 20px;
        cursor: pointer;
    }
    .tab-item.active {
        color:#1E63B0;
        border-bottom: 3px solid #1E63B0
    }
}
.bg-grey {
    background-color:  #F9F9F9;
}
.tab-content {
    width: 100%;
    .tab-content-item {
        width: 100%;
        .welcome {
            width: 100%;
            background-color: #fff;
            font-size: 28px;
            font-weight: normal;
            color: #474747;
            line-height: 45px;
            text-align: center;
            margin: 25px 0;
        }
    }
}
.tab-content-part {
    position: relative;
    padding: 20px 0;
    .title {
        text-align: center;
        font-size: 24px;
        font-weight: 600;
        color: #1E63B0;
        line-height: 40px;
        padding: 20px 0;
        position: relative;
    }
    .title::after {
        position: absolute;
        content: "";
        width: 50px;
        height: 3px;
        bottom: 10px;
        left: 50%;
        margin-left: -25px;
        background: #DBDBDB;
        border-radius: 2px;
    }
    .desc {
        text-align: center;
        font-size: 14px;
        font-weight: normal;
        color: #474747;
        line-height: 28px;
        padding: 0 16px;
    }
    .appli-button {
        width: 200px;
        height: 38px;
        cursor: pointer;
        line-height: 38px;
        background: #1E63B0;
        border-radius: 3px;
        color: #FFFFFF;
        text-align: center;
        margin: 20px auto 0;
    }
    .img-box {
        position: relative;
        margin-top: 20px;
        margin-bottom: 20px;
        height: auto;
        text-align: center;
        .tab-img {
            max-width: 100%;
            position: static;
            margin: 0;
            transform: none;
        }
    }
}
.ro-tab {
    display: flex;
    .ro-tab-item {
        margin-right: 20px;
        font-size: 16px;
        font-weight: normal;
        color: #474747;
        line-height: 40px;
        cursor: pointer;
    }
    .ro-tab-item.active {
        color: #1E63B0;
        border-bottom: 2px solid #1E63B0;
    }
}
.sub-tab-desc {
    margin-top: 15px;
    p {
        font-size: 14px;
        font-weight: normal;
        color: #474747;
        line-height: 32px;
    };
}
.constitution {
    span {
        font-size: 16px;
        font-weight: normal;
        color: #474747;
        line-height: 32px;
    }
}
/* 响应式 */
@media (max-width: 768px) {
    .main-box {
        padding: 0 12px;
    }
    .tabs .tab-item {
        font-size: 16px;
        margin: 0 12px;
        line-height: 44px;
    }
    .tab-content .tab-content-item .welcome {
        font-size: 22px;
        margin: 20px 0;
    }
    .tab-content-part .title {
        font-size: 20px;
    }
}
@media (min-width: 1024px) {
    .tabs .tab-item {
        font-size: 26px;
        margin: 0 40px;
    }
    .tab-content .tab-content-item .welcome {
        font-size: 32px;
        margin: 35px 0;
    }
    .tab-content-part .title {
        font-size: 28px;
    }
}
</style>
